module.exports = __webpack_public_path__ + "img/sm.b70bc5ab.png";